import { type FC } from 'react'
import { HashtagChips } from '../../../components/CustomWorkflows/tags/HashtagChips'
import { FilterChip } from '../../../components/CustomWorkflows/tags/FilterChip'
import { WORKFLOW_CATEGORY_KEYS, type WorkflowCategoryKey } from '../../../components/CustomWorkflows/workflowTags'
import { type LibraryCatalog, type LibraryFilter } from './libraryCatalog'

interface LibraryFiltersProps {
  catalog: LibraryCatalog
  onChange: (filter: LibraryFilter) => void
}

const asCategory = (key: string): WorkflowCategoryKey | 'all' => WORKFLOW_CATEGORY_KEYS.find((category) => category === key) ?? 'all'

export const LibraryFilters: FC<LibraryFiltersProps> = ({ catalog, onChange }) => {
  const { categories, quickTags, selected } = catalog
  if (categories.length <= 1 && quickTags.length === 0) {
    return null
  }
  return (
    <div className='d-flex flex-column zocks-gap-2'>
      {categories.length > 1 ? (
        <div className='d-flex flex-wrap gap-1' role='group' aria-label='Filter workflows by category'>
          {categories.map((option) => (
            <FilterChip
              key={option.key}
              pressed={selected.category === option.key}
              label={option.label}
              icon={option.icon}
              count={option.count}
              onClick={() => onChange({ ...selected, category: asCategory(option.key) })}
            />
          ))}
        </div>
      ) : null}
      {quickTags.length > 0 ? (
        <HashtagChips
          tags={quickTags.map((quickTag) => quickTag.tag)}
          selected={selected.tag}
          onSelect={(tag) => onChange({ ...selected, tag: selected.tag === tag ? null : tag })}
        />
      ) : null}
    </div>
  )
}
